export default {
    data() {
        return {
            dictionaries: {
                thesesTypes: [
                    {id: 'keyConclusions', name: 'Ключевые выводы'},
                    {id: 'problems', name: 'Проблемы'},
                    {id: 'decisions', name: 'Решения'},
                ]
            },
        };
    },
}
